enum HOSPITAL_ACTION_TYPES {
  FETCH_CALENDAR_EVENT = 'FETCH_CALENDAR_EVENT',
  FETCH_CALENDAR = 'FETCH_CALENDAR',
  HOSPITAL_PROFILE = 'HOSPITAL_PROFILE',
  FETCH_ADMIN_SWITCH = 'FETCH_ADMIN_SWITCH',
  FETCH_ENABLE_DISABLE_CLICK = 'FETCH_ENABLE_DISABLE_CLICK',
  HOSPITAL_PROFILE_DATA = 'HOSPITAL_PROFILE_DATA',
  IS_LOGOUT_CLICKED = 'IS_LOGOUT_CLICKED',
  SET_NEW_ENTRY = 'SET_NEW_ENTRY',
  HOSPITAL_LOGO = 'HOSPITAL_LOGO',
  FETCH_HOSPITAL_LOGO = 'FETCH_HOSPITAL_LOGO',
  INFRA_IMAGES = 'INFRA_IMAGES',
  FETCH_INFRA_IMAGES = 'FETCH_INFRA_IMAGES',
  FETCH_IP_INCLUSION_MASTER = 'FETCH_INCLUSION_MASTER_IP',
  IP_INCLUSION_MASTER_DATA = 'INCLUSION_MASTER_DATA_IP',
  FETCH_IP_DEPARTMENT_MASTER = 'FETCH_IP_DEPARTMENT_MASTER',
  IP_DEPARTMENT_MASTER_DATA = 'IP_DEPARTMENT_MASTER_DATA',
  FETCH_DAYCARE_DEPARTMENT_MASTER = 'FETCH_DAYCARE_DEPARTMENT_MASTER',
  DAYCARE_DEPARTMENT_MASTER_DATA = 'DAYCARE_DEPARTMENT_MASTER_DATA',
  FETCH_DAYCARE_INCLUSION_MASTER = 'FETCH_INCLUSION_MASTER_DAYCARE',
  DAYCARE_INCLUSION_MASTER_DATA = 'INCLUSION_MASTER_DATA_DAYCARE',
  FETCH_AMENITY_MASTER = 'FETCH_AMENITY_MASTER',
  AMENITY_MASTER_DATA = 'AMENITY_MASTER_DATA',
  GET_SELECTED_HOSP_INFO = 'GET_SELECTED_HOSP_INFO',
  SET_SELECTED_HOSP_INFO = 'SET_SELECTED_HOSP_INFO',
  SET_PATIENT_LIST = 'SET_PATIENT_LIST',
  SET_HIS_CARD_DISPLAY_PARAMETERS = 'SET_HIS_CARD_DISPLAY_PARAMETERS',
  SET_SELECTED_PATIENT_DATA = 'SET_SELECTED_PATIENT_DATA',
  SET_HOSPITAL_SEARCH_VALUES = 'SET_HOSPITAL_SEARCH_VALUES',
  GET_HIS_DOCTORS_LIST = 'GET_HIS_DOCTORS_LIST',
  SET_HIS_DOCTOR_LIST = 'SET_HIS_DOCTOR_LIST',
  IS_LOGOUT_BTN_CLICKED = 'IS_LOGOUT_BTN_CLICKED',
  GET_TICKER_CONFIGURATION = 'GET_TICKER_CONFIGURATION',
  GET_PATIENT_VISIT_DETAILS = 'GET_PATIENT_VISIT_DETAILS',
  GET_PATIENT_ALL_VISITS_DETAILS = 'GET_PATIENT_ALL_VISIT_DETAILS',
  SET_HIS_CARD_SELECTED = 'SET_HIS_CARD_SELECTED',
  SET_IS_HIS_CLAIM = 'SET_IS_HIS_CLAIM',
  SET_IS_USER_EMAIL_VERIFIED = 'SET_IS_USER_EMAIL_VERIFIED',
  UPDATE_HOSPITAL_SEAL = 'UPDATE_HOSPITAL_SEAL',
  SET_SUGGESTED_VALUES_MAP = 'SET_SUGGESTED_VALUES_MAP',
  SET_IS_AUTOMATED_NEW_ADMISSION = 'SET_IS_AUTOMATED_NEW_ADMISSION',
  SET_HIS_TREATMENT_DETAILS = 'SET_HIS_TREATMENT_DETAILS',
  SET_IS_HIS_PACKAGE_FILLED = 'SET_IS_HIS_PACKAGE_FILLED',
  SET_PARSED_HIS_VALUES_MAP = 'SET_PARSED_HIS_VALUES_MAP',
}

export default HOSPITAL_ACTION_TYPES;
